<template>
  <div style="display: inline">
    <u data-toggle="popover" data-trigger="hover" data-placement="bottom" :data-content="hidden">{{displayed}}</u>
    <i class="fa fa-info-circle d-print-none" aria-hidden="true"></i>
  </div>
</template>

<script>
export default {
 props: ['displayed', 'hidden']
}
$(document).ready(function(){
    $('[data-toggle="popover"]').popover();
});
</script>